module.exports = __webpack_public_path__ + "media/images/cotizacion-3c7999d1.png";